import { createFileRoute } from "@tanstack/react-router";
import { routeMeta } from "@/lib/route-meta";
import Auth from "@/pages/Auth";

export const Route = createFileRoute("/auth")({ head: () => routeMeta('Sign In | MNRE', 'Sign in securely to access your MNRE account.', '/auth'), component: Auth });
